import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { qualityclr } from "../../../../../../constants/Constant";
import Spinner from "../../../../../../utils/Spinner";

const TableQualityTable = (props) => {
  const tablequality = props.tablequalitytable;
  const fetching = props.fetching;

  return (
    <>
      {" "}
      {fetching ? (
        <div className="justify-content-md-center">
          {" "}
          <Spinner />
        </div>
      ) : (
        <ReactTable
          data={tablequality}
          sortable={true}
          size="sm"
          showPagination={true}
          style={{
            height: "300px",
          }}
          columns={[
            {
              Header: () => <div className="column__table__header">Date</div>,
              accessor: "updatedAt",
            },
            {
              Header: () => (
                <div className="column__table__header">Table Quality</div>
              ),
              Cell: (row, i) => (
                <div
                  className="col-xs-1 w-25 quality__tab"
                  style={{
                    backgroundColor: qualityclr[row.original.metricclr],
                  }}
                >
                  <div className="text-center table__metric">
                    <span>{row.original.metricValue + "%"}</span>
                  </div>
                </div>
              ),
            },
          ]}
          defaultPageSize={5}
        />
      )}
    </>
  );
};

export default TableQualityTable;
